let localePrefix = '/';

/*if (window.locale.baseUrls[window.locale.current] !== '/') {
  localePrefix = window.locale.baseUrls[window.locale.current] + '/';
}*/

const isPageVariantOrganization = document.body.classList.contains('is-page-variant-organization');
const isPageVariantShop = document.body.classList.contains('is-page-variant-shop');

/**
 * Intro animation
 */
if (document.querySelector('.animation_block')) {
  const organization_href = document.querySelector('.organization_href');
  const orgAnimationElements = document.querySelectorAll('.hero_organization_block');
  const shopAnimationElements = document.querySelectorAll('.hero_shop_block');
  const video_block = document.querySelector('.video_block');
  const animation_block = document.querySelector('.animation_block');
  const enterButton = document.querySelector('.hero_text');
  const shop_href = document.querySelector('.shop_href');

  function animateElements(elements) {
    let index = 0;
    const interval = setInterval(() => {
      if (index < elements.length) {
        elements.item(index).classList.add('active');

        if (index > 0) {
          elements.item(index - 1).classList.remove('active');
        }
        index++;
      } else {
        clearInterval(interval);
      }
    }, 200); //110 300
  }

  /*const startAnimations = () => {
    console.log("start animations");
    let counter = 0;

    orgAnimationElements.forEach((element) => {
        element.addEventListener("animationend", () => {   
          if (counter > 0) {
            orgAnimationElements.item(counter - 1).classList.remove('active');
          }
          shopAnimationElements.item(counter).classList.add('active');
        });
    })

    shopAnimationElements.forEach((element) => {
        element.addEventListener("animationend", () => {   
          if (counter > 0) {
            shopAnimationElements.item(counter - 1).classList.remove('active');
          }
          counter++;
          orgAnimationElements.item(counter).classList.add('active');
        });
    })
    
    orgAnimationElements.item(0).classList.add('active');
  }*/

  enterButton.addEventListener('click', () => {
    animation_block.classList.remove('none');
    video_block.classList.add('none');

    //startAnimations();
    animateElements(orgAnimationElements);
    // Delay shop elements by half the interval to run them after each other
    setTimeout(() => animateElements(shopAnimationElements), 100); //55 150
  });

  organization_href.addEventListener('click', () => {
    if (animation_block.classList.contains('orgAnimationActive')) {
      animation_block.classList.remove('orgAnimationActive');
    } else {
      animation_block.classList.add('orgAnimationActive');
      animation_block.classList.remove('shopAnimationActive');
    }
    setTimeout(() => (document.location.href = `${localePrefix}pages/organization?_a`), 100);
  });
  shop_href.addEventListener('click', () => {
    if (animation_block.classList.contains('shopAnimationActive')) {
      animation_block.classList.remove('shopAnimationActive');
    } else {
      animation_block.classList.add('shopAnimationActive');
      animation_block.classList.remove('orgAnimationActive');
    }
    setTimeout(() => (document.location.href = `${localePrefix}pages/shop?_a`), 100);
  });
}

const checkLocation = window.location.href;

if (checkLocation.includes('customer_posted=true')) {
  document.querySelector('.page-container').classList.add('message');
}

if (isPageVariantShop) {
  if (checkLocation.includes('search')) {
    if (document.querySelector('.page-width')) {
      if (document.querySelectorAll('.list-view-item').length > 0) {
      } else {
        document.querySelector('.h2').innerHTML = 'Sorry, no results found';
      }
      document.querySelector('.page-width').classList.add('result');
      if (document.querySelector('.list--inline.pagination')) {
        document.querySelector('.list--inline.pagination').style.display = 'none';
      }
    }
  }

  if (checkLocation.includes('products/')) {
    function product_card_display() {
      let pdp_display_none_card_title = document.querySelectorAll('.product-card__title');
      let pdp_display_none_card_tagname = document.querySelectorAll('.collection_metafield_tagname');
      let pdp_display_none_card_description = document.querySelectorAll('.collection_metafield_second_description');
      let price_dl_new = document.querySelectorAll('.price_dl_new');
      let product_image_grid_width = document.querySelectorAll('.product_image_grid_width');
      let product_image_grid_width_block = document.querySelectorAll('.product_image_grid_width_block');

      pdp_display_none_card_title.forEach((element, i) => {
        pdp_display_none_card_title[i].classList.add('product_display_none');
        pdp_display_none_card_tagname[i].classList.add('product_display_none');
        pdp_display_none_card_description[i].classList.add('product_display_none');
        price_dl_new[i].classList.add('product_display_none');
        product_image_grid_width[i].classList.add('product_image_grid_width_hundred');
        product_image_grid_width_block[i].classList.add('product_image_grid_width_block_hundred');
      });
    }
    setTimeout(product_card_display, 500);
  }
}

let screenWidth = document.documentElement.clientWidth;
let insertWidth = screenWidth / 2 + 64;

if (document.querySelector('.shop_header_container')) {
  let seach_img = document.querySelector('.seach_img.pc');
  let cloudCencel = document.querySelector('.cloud-search-mobile__cancel');
  let shop_form_seach = document.querySelector('.shop_form_seach.pc');
  seach_img.addEventListener('click', () => {
    if (shop_form_seach.classList.contains('open_seach')) {
      shop_form_seach.classList.remove('open_seach');
    } else {
      shop_form_seach.classList.add('open_seach');
    }
  });
  if (cloudCencel) {
    cloudCencel.addEventListener('click', () => shop_form_seach.classList.remove('open_seach'));
  }

  const seach_imgMob = document.querySelector('.seach_img.mob');
  const shop_form_seachMob = document.querySelector('.shop_form_seach.mob');
  seach_imgMob.addEventListener('click', () => {
    if (shop_form_seachMob.classList.contains('open_seach')) {
      shop_form_seachMob.classList.remove('open_seach');
    } else {
      shop_form_seachMob.classList.add('open_seach');
    }
  });

  if (cloudCencel) {
    cloudCencel.addEventListener('click', () => {
      shop_form_seachMob.classList.remove('open_seach');
    });
  }

  const shop_mob_first = document.querySelector('.shop_mob_first');
  const shop_mob__heading = document.querySelectorAll('.shop_mob__heading');
  const shop_mob_img_box = document.querySelectorAll('.shop_mob_img_box');

  shop_mob_first.addEventListener('click', function (e) {
    if (e.target.closest('.shop_mob__heading')) {
      if (!e.target.closest('.shop_mob__heading').classList.contains('open_mob_heading')) {
        shop_mob__heading.forEach(element => element.classList.remove('open_mob_heading'));
        e.target.closest('.shop_mob__heading').classList.add('open_mob_heading');
      }
      shop_mob__heading.forEach((element, i) => {
        if (shop_mob__heading[i].classList.contains('open_mob_heading')) {
          if (!shop_mob_img_box[i].classList.contains('open_mob_heading')) {
            shop_mob_img_box.forEach(element => element.classList.remove('open_mob_heading'));
            shop_mob_img_box[i].classList.add('open_mob_heading');
          }
        }
      });
    }
  });
}

if (document.querySelectorAll('.media_url_text.readmore')) {
  let readless = document.querySelectorAll('.media_url_text.minimize');
  let readmore = document.querySelectorAll('.media_url_text.readmore');

  readmore.forEach(function (item) {
    item.addEventListener('click', function () {
      item.parentNode.classList.add('open');
    });
  });
  readless.forEach(function (item) {
    item.addEventListener('click', function () {
      item.parentNode.classList.remove('open');
    });
  });
}

document.querySelectorAll('.swiper-container.gallery_container.stories_container').forEach(container => {
  new Swiper(container, {
    slidesPerView: 1,
    grabCursor: true,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
});

document.querySelectorAll('.swiper-container.hero_slider_container').forEach(container => {
  const slides = container.querySelectorAll('.swiper-slide');
  new Swiper(container, {
    slidesPerView: 1,
    grabCursor: true,
    loop: true,
    autoHeight: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 15000,
      disableOnInteraction: false,
    },
    on: {
      slideChangeTransitionEnd: function () {
        const videoEl = Array.from(slides)[this.realIndex].querySelector('.hero_slider_video');
        if (videoEl) {
          const videoElSource = videoEl.querySelector('source');
          if (videoElSource.dataset.src) {
            videoElSource.src = videoElSource.dataset.src;
            videoElSource.removeAttribute('data-src');
            videoEl.load();
            videoEl.play();
          }
        }
      },
    },
  });
});

if (document.querySelector('.fixed_block')) {
  document.querySelector('.header_section.blog_header').appendChild(document.querySelector('.fixed_block'));

  document.querySelector('.closeBtnGallery').addEventListener('click', () => {
    document.querySelector('.fixed_block').classList.remove('open_gallery');
    document.querySelector('.header_section').classList.remove('open_gallery');
  });
  document.querySelector('.openBtnGallery').addEventListener('click', () => {
    document.querySelector('.fixed_block').classList.add('open_gallery');
    document.querySelector('.header_section').classList.add('open_gallery');
  });

  document.querySelectorAll('.swiper-container.fixed_gallery_container').forEach(container => {
    new Swiper(container, {
      slidesPerView: 1,
      grabCursor: true,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
    });
  });
}

document.querySelectorAll('.project_slider_section .swiper-container').forEach(container => {
  new Swiper(container, {
    slidesPerView: 'auto',
    grabCursor: true,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
      300: {
        slidesPerView: 'auto',
      },
      765: {
        slidesPerView: 'auto',
      },
      1023: {
        slidesPerView: 4,
      },
    },
  });
});

document.querySelectorAll('.shop_image_section .swiper-container').forEach(container => {
  new Swiper(container, {
    slidesPerView: 1,
    grabCursor: true,
    loop: true,
    autoHeight: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });
});

/**
 * Donate section
 */
if (document.querySelector('.donate_padding')) {
  const donateEls = Array.from(document.querySelectorAll('.donate-element'));
  const inputEl = document.querySelector('.btn_donate_input');
  let currentAmount = 0;

  function setAmount(amount, elements) {
    currentAmount = +amount;
    elements.forEach(el => {
      if (el.getAttribute('data-amount') === amount.toString()) {
        el.classList.add('active');
      } else {
        el.classList.remove('active');
      }
    });
  }

  donateEls.forEach(el =>
    el.addEventListener('click', () => {
      setAmount(+el.getAttribute('data-amount'), donateEls);
    })
  );
  inputEl.addEventListener('click', () => setAmount(-1, donateEls));

  // Set first amount on-init
  setAmount(donateEls[0].getAttribute('data-amount'), donateEls);

  document.getElementById('donation_form').addEventListener('submit', () => {
    if (currentAmount === -1) {
      currentAmount = inputEl.value;
    }
    document.getElementById('donation_amount').value = currentAmount;
  });
}

if (document.querySelector('.donate_box')) {
  document.querySelector('.hidden_block').style.display = 'none';

  const donateBlocks = document.querySelectorAll('.donate_block');
  const initialHeights = Array.from(donateBlocks).map(block => block.clientHeight);

  donateBlocks.forEach((donateBlock, blockIndex) => {
    const heading = donateBlock.querySelector('.donate_heading');
    const formContainer = donateBlock.querySelector('.donate_form_block');

    heading.addEventListener('click', () => {
      donateBlocks.forEach((block, i) => {
        // Close all other blocks
        if (i !== blockIndex) {
          block.style.height = `${initialHeights[i]}px`;
          block.classList.remove('open_block');
        }
      });

      const wasOpen = donateBlock.classList.contains('open_block');

      if (!wasOpen) {
        donateBlock.classList.add('open_block');
        formContainer.style.top = `${donateBlock.clientHeight + 16}px`;
        donateBlock.style.height = `${donateBlock.clientHeight + formContainer.scrollHeight + 32}px`;
      }
    });
  });
}

if (checkLocation.includes('products')) {
  const productDescriptionMore = document.querySelector('.product_description_more');
  const btnShowMore = document.querySelector('.product_description_btn.description_btn_more');
  const btnShowLess = document.querySelector('.product_description_btn.description_btn_less');
  if (btnShowMore && btnShowLess) {
    btnShowMore.addEventListener('click', () => {
      productDescriptionMore.style.display = 'inline';
      btnShowMore.style.display = 'none';
      btnShowLess.style.display = 'inline-block';
    });
    btnShowLess.addEventListener('click', () => {
      productDescriptionMore.style.display = 'none';
      btnShowMore.style.display = 'inline-block';
      btnShowLess.style.display = 'none';
    });
  }
}

/**
 * Setup embedded videos.
 */
const embeddedVideos = document.getElementsByClassName('video-embed');
Array.from(embeddedVideos).forEach(videoEl => {
  const type = videoEl.getAttribute('data-type');
  const videoId = videoEl.getAttribute('data-video-id');
  const posterImg = videoEl.getAttribute('data-poster-src');

  const posterEl = document.createElement('img');
  posterEl.setAttribute('src', posterImg);
  posterEl.setAttribute('class', 'thumb');

  const playContainer = document.createElement('div');
  playContainer.setAttribute('class', 'play');

  videoEl.appendChild(posterEl);
  videoEl.appendChild(playContainer);
  videoEl.onclick = function () {
    const iFrame = document.createElement('iframe');

    switch (type) {
      case 'youtube': {
        iFrame.setAttribute('src', `https://www.youtube.com/embed/${videoId}`);
        break;
      }
      case 'vimeo': {
        iFrame.setAttribute('src', `https://player.vimeo.com/video/${videoId}?title=0&byline=0&portrait=0`);
        break;
      }
      default: {
        console.error('Invalid video type');
        break;
      }
    }

    iFrame.classList.add('blog_video');
    this.parentNode.replaceChild(iFrame, this);
  };
});

/**
 * Hover effect for product photos. (product-photos-hover-slider)
 */
const productPhotosHoverSliders = Array.from(document.querySelectorAll('.product-photos-hover-slider'));

if (productPhotosHoverSliders.length > 0) {
  productPhotosHoverSliders.forEach(hoverSlider => {
    let hoverEffectIntervall;
    const loadingBar = hoverSlider.querySelector('.loading-bar');
    const images = Array.from(hoverSlider.querySelectorAll('.hover-slide'));
    const imageCount = parseInt(hoverSlider.dataset.imageCount);

    hoverSlider.addEventListener('mouseenter', () => {
      let i = 1;
      loadingBar.style.height = `${((1 % imageCount) / imageCount) * 100}%`;
      hoverEffectIntervall = setInterval(() => {
        images.forEach(image => image.classList.remove('is-active'));
        images[i % imageCount].classList.add('is-active');
        if ((i + 1) % imageCount === 0) {
          // When bar is 100%
          loadingBar.style.height = '100%';
          i++;
        } else if (i % imageCount === 0) {
          // Reset loading bar without transition when it was full
          loadingBar.style.transition = 'none';
          loadingBar.style.height = '0%';
          setTimeout(() => {
            loadingBar.style.removeProperty('transition');
            loadingBar.style.height = `${(((i + 1) % imageCount) / imageCount) * 100}%`;
            i++;
          }, 10);
        } else {
          // Normal progress calculation
          loadingBar.style.height = `${(((i + 1) % imageCount) / imageCount) * 100}%`;
          i++;
        }
      }, 1500);
    });

    hoverSlider.addEventListener('mouseout', () => {
      clearInterval(hoverEffectIntervall);
      // Reset images
      images.forEach(image => image.classList.remove('is-active'));
      images[0].classList.add('is-active');
      // Reset loading bar
      loadingBar.style.height = 0;
      loadingBar.style.transition = 'none';
      loadingBar.style.height = '0%';
      setTimeout(() => {
        loadingBar.style.removeProperty('transition');
      }, 10);
    });
  });
}

/**
 * Language Switcher
 *
 * Automatically injects the LangShop language switcher into a container `#language-switcher`.
 *
 * @see https://langshop.app/documentation/js/events
 * @see https://langshop.app/documentation/js/methods
 */
const languageSwitchContainer = document.querySelector('#language-switcher');
window.addEventListener('langshop:loaded', () => {
  
  if (!languageSwitchContainer) {
    return;
  }

  

  LangShopSDK.on('ready', () => {
    const [switcher] = LangShopSDK.langShop.languagesSwitchers;

    // Prevent branding from showing up
    switcher.shouldCreateBranding = () => false;

    switcher.update(
      {
        target: languageSwitchContainer,
        type: 'inline',
        position: 'relative',
        display: 'titles',
        defaultStyles: false,
        status: 'published',
      },
      LangShopSDK.langShop.getLanguages(),
      LangShopSDK.langShop.getCurrentLanguage().code
    );

    const navEntries = document.querySelectorAll(".navigation_text, .ls-text");
  
    navEntries.forEach((link) => {
      link.addEventListener('mouseenter', (event) => {
    	        
        navEntries.forEach((link) => {
    		link.style.color = "#414141"; 
        });

        event.target.style.color = "#ffffff"; 
      });
    
      link.addEventListener('mouseleave', e => {
        navEntries.forEach((link) => {
              link.style.color = "#ffffff"; 
          });
      });
    });
  });

  /**
   * Use the `afterSwitcherCreated` event to replace the language names with their respective ids, if we are on the shop variant of the page.
   */
  if (isPageVariantShop) {
    LangShopSDK.on('afterSwitcherCreated', function (container, type) {
      container.querySelectorAll('li').forEach(element => {
        const langCode = element.getAttribute('data-code');
        element.querySelector('.ls-text').innerText = langCode;
      });
    });
  }
});

const iconMenu = document.querySelector('.menu_icon');
if (iconMenu) {
  const menuBody = document.querySelector('.menu_body');
  iconMenu.addEventListener('click', () => {
    document.body.classList.toggle('lock');
    iconMenu.classList.toggle('active');
    menuBody.classList.toggle('active');
  });
}

const iconMenuShop = document.querySelector('.menu_icon_shop');
if (iconMenuShop) {
  const menuBody = document.querySelector('.shop_menu_body');
  iconMenuShop.addEventListener('click', () => {
    document.body.classList.toggle('lock');
    iconMenuShop.classList.toggle('active');
    menuBody.classList.toggle('active');
    if (languageSwitchContainer) {
      languageSwitchContainer.classList.toggle('active');
    }
  });
}

const lazyImages = document.querySelectorAll('img[data-src]');
const windowHeight = document.documentElement.clientHeight;

let lazyImagesPositions = [];
if (lazyImages.length > 0) {
  lazyImages.forEach(img => {
    if (img.dataset.src) {
      lazyImagesPositions.push(img.getBoundingClientRect().top + pageYOffset);
      lazyScrollCheck();
    }
  });
}

function setHeaderScrollState() {
  if (document.querySelector('.header_section')) {
    let headerSection = document.querySelector('.header_section');
    let nav = document.body;
    if (window.pageYOffset > 30) {
      nav.classList.add('scroll');
      headerSection.classList.add('scroll');
    } else {
      nav.classList.remove('scroll');
      headerSection.classList.remove('scroll');
    }
  }
}

function lazyScrollCheck() {
  let imgIndex = lazyImagesPositions.findIndex(item => pageYOffset > item - windowHeight);
  if (imgIndex >= 0) {
    if (lazyImages[imgIndex].dataset.src) {
      lazyImages[imgIndex].src = lazyImages[imgIndex].dataset.src;
      lazyImages[imgIndex].removeAttribute('data-src');
    }
    delete lazyImagesPositions[imgIndex];
  }
}

window.addEventListener('scroll', () => {
  if (document.querySelectorAll('img[data-src]').length > 0) {
    lazyScrollCheck();
  }
  setHeaderScrollState();
});
setHeaderScrollState();

/**
 * Full-page loading transition
 */
setTimeout(() => document.querySelector('body').classList.remove('loading'), 100);

if (document.querySelector('.header_goToPageBlog')) {
  document.querySelector('.header_goToPageBlog').addEventListener('click', () => {
    document.querySelector('body').classList.add('loading-blog');
    setTimeout(() => (document.location.href = `${localePrefix}pages/organization?_a`), 1000);
  });
}

if (document.querySelector('.header_goToPageShop')) {
  document.querySelector('.header_goToPageShop').addEventListener('click', () => {
    document.querySelector('body').classList.add('loading-shop');
    setTimeout(() => (document.location.href = `${localePrefix}pages/shop?_a`), 1000);
  });
}

/**
 * Video block mute/unmute
 */

const heroVideoSections = document.querySelectorAll('.hero_section .video_block');
Array.from(heroVideoSections).forEach(heroVideoSection => {
  const muteUnmuteButton = heroVideoSection.querySelector('.mute-unmute-button');
  const videoElement = heroVideoSection.querySelector('.video-block-video');
  const iconMuted = heroVideoSection.querySelector('.icon-muted');
  const iconUnmuted = heroVideoSection.querySelector('.icon-unmuted');

  muteUnmuteButton.addEventListener('click', () => {
    videoElement.muted = !videoElement.muted;
    if (videoElement.muted) {
      iconMuted.classList.remove('is-hidden');
      iconUnmuted.classList.add('is-hidden');
    } else {
      iconMuted.classList.add('is-hidden');
      iconUnmuted.classList.remove('is-hidden');
    }
  });
});



  